module.exports = __webpack_public_path__ + "simquadrat.svg?7ee5cab56d626a9f26cf7eb9658f4ccf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/simquadrat.svg
// module id = 97
// module chunks = 0